var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"node-chrome",class:_vm.hideClass},[_c('div',{directives:[{name:"permission",rawName:"v-permission",value:('full'),expression:"'full'"}]},[_c('SpacingBars'),_c('ColumnDragSizer')],1),_c('NodeTitlebar'),_c('NodeHoverControls'),_c('NodeContentEditable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }